import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { Context } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import { CONTEXTS_COLUMN_ID } from "../constants";
import useCellCopyAction from "../useCellCopyAction";

const ContextTableCreatedAtCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  const copyAction = useCellCopyAction({
    column: CONTEXTS_COLUMN_ID.CREATED_AT,
    text: makeTimestampToCopy(context.createdAt),
  });

  const isEmpty = !context.createdAt;

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [copyAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {!isEmpty && <Timestamp timestamp={context.createdAt} />}
    </TableSimpleCell>
  );
};

export default ContextTableCreatedAtCell;
